import { Component, OnDestroy, OnInit } from '@angular/core';
import { OrdersFacade } from '@kion/data-access/data-access-orders';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { Basket, Device, Order } from '@kion/data-models';
import { map } from 'rxjs/operators';
import { DevicesFacade } from '@kion/data-access/data-access-devices';
import { CmsConfig } from '../../config/cms.config';
import { CorrelationObserverService } from '@kion/ngrx-helper';
import { BasketsFacade } from '@kion/data-access/data-access-baskets';
import { SubSink } from 'subsink';

@Component({
  selector: 'kion-cms-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss']
})
export class OrderConfirmationComponent implements OnInit, OnDestroy {

  order$: Observable<Order | Basket>;
  orderId: string;
  device$: Observable<Device>;

  project: 'FS' | 'LR' | string;

  private readonly subSink: SubSink;

  constructor(
    private ordersFacade: OrdersFacade,
    private route: ActivatedRoute,
    private devicesFacade: DevicesFacade,
    private cmsConfig: CmsConfig,
    private observer: CorrelationObserverService,
    private basketsFacade: BasketsFacade
  ) {
    this.subSink = new SubSink();
  }

  ngOnInit(): void {
    this.project = this.cmsConfig.project;
    let couldNotLoadedOrder = false;
    this.orderId = this.route.snapshot.params.orderId;
    this.subSink.sink = this.observer.subscribeToAction(
      this.ordersFacade.loadOrderById(this.orderId, this.orderId),
      () => { },
      () => {
        couldNotLoadedOrder = true;
        if (this.project === 'LR') {
          this.order$ = this.basketsFacade.order$
        }
      }
    );
    if (!couldNotLoadedOrder){
      this.order$ = this.ordersFacade.all$.pipe(
        map(
          orders => orders.find(order => order.id === this.orderId)
        )
      );
    }
    if (this.project === 'FS') {
      this.subSink.sink = this.order$.subscribe((order: Order) => {
        if (order) {
          if (order.device) {
            this.devicesFacade.loadById(order.device.manufacturer, order.device.serialNumber);
            }
          }
        }
      );
      this.device$ = combineLatest(
        [
          this.devicesFacade.all$,
          this.order$
        ]
      ).pipe(
        map(
          ([devices, order]) => {
            if (order) {
              // @ts-ignore
              if(order.device) {
                return devices.find(
                  // @ts-ignore
                  device => device.serialNumber === order.device.serialNumber && device.manufacturer === order.device.manufacturer
                )
              }
            }
          }
        )
      );
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
